import React, { useState } from "react";
import {Link} from "react-router-dom";
import {TripUserCreateRoute, TripUserEditRoute} from "../../../routesConstants";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../../components/Portlet";
import PortletHeaderSearch from "../../../base/components/forms/portlerHeaderSearch";
import DataTable from "../../../../components/dataTable";
import numberFormat from "../../../../helpers/numberFormat";
import {Helmet} from "react-helmet";


const TripUsersList = () => {
  const columns = [
    {
      Header: "Email",
      accessor: "email",
      Cell: ({ value, row }) => (
        <Link to={TripUserEditRoute + row.original.id}>{value}</Link>
      )
    },
    {
      Header: "Имя",
      accessor: "firstName"
    },
    {
      Header: "Фамилия",
      accessor: "lastName"
    },
    {
      Header: "Бонусы",
      accessor: "bonusPoints",
      Cell: ({ value, row }) => {
        return(numberFormat(value))
      }
    },
    {
      Header: "Активен",
      accessor: "active",
      Cell: ({ value, row }) => (
        <>
          {value ? (
            <i className={"fa fa-check-circle text-success"} />
          ) : (
            <i className={"fa fa-times-circle text-danger"} />
          )}
        </>
      )
    }
  ];

  const [query, setQuery] = useState("");
  return (
    <>
      <Helmet>
        <title>Туристы</title>
      </Helmet>
      <Portlet>
        <PortletHeader
          title={"Список пользователей"}
          toolbar={
            <PortletHeaderToolbar>
              <PortletHeaderSearch
                value={query}
                cb={v => {
                  setQuery(v);
                }}
              />
              <Link
                to={TripUserCreateRoute}
                className="btn btn-sm btn-brand btn-elevate btn-icon-sm"
              >
                <i className="la la-plus" />
                Добавить
              </Link>
            </PortletHeaderToolbar>
          }
        />
        <PortletBody>
          <DataTable search={query} url={"/api/trips/users"} columns={columns} />
        </PortletBody>
      </Portlet>
    </>
  );
};

export default TripUsersList;
